import {
  SmartAccount,
  type AccountContract,
  type AccountContractConfig,
  type IEthereumProvider,
} from '@particle-network/aa';
import { isEVMChain } from '@particle-network/connector-core';
import { createPlugin, type Plugin } from '@particle-network/plugin-core';

export type WalletPluginProperties = {
  erc4337: AccountContract;
  smartAccount: SmartAccount | null;
};

export type AAPlugin = Plugin<SmartAccount | null, void, WalletPluginProperties>;

export type AAPluginParamers = AccountContract;

let previousSmartAccount: SmartAccount | null = null;

export const aa = (paramers: AAPluginParamers) => {
  if (!paramers || !paramers.name || !paramers.version) {
    throw new Error('AA Plugin paramers error.');
  }

  const { name, version } = paramers;
  return createPlugin<SmartAccount | null, void, WalletPluginProperties>((config) => ({
    get id() {
      return 'aa';
    },
    get name() {
      return 'Account Abstraction';
    },
    get erc4337() {
      return { name, version };
    },
    get smartAccount() {
      return previousSmartAccount;
    },
    getPlugin() {
      return previousSmartAccount;
    },
    async onConnect(connection) {
      const connector = connection[0].connector;

      if (connector.chainType === 'evm') {
        const provider = await connector.getProvider();
        if (previousSmartAccount?.provider === provider) {
          return;
        }
        const { projectConfig, chains } = config;
        const accountContracts = {} as { [key: string]: AccountContractConfig[] };
        accountContracts[name] = [
          {
            version,
            chainIds: chains.filter(isEVMChain).map((chain) => chain.id),
          },
        ];
        const smartAccount = new SmartAccount(provider as IEthereumProvider, {
          ...projectConfig,
          aaOptions: { accountContracts },
        });
        previousSmartAccount = smartAccount;
      } else {
        previousSmartAccount = null;
      }
    },
    async onDisconnect() {
      previousSmartAccount = null;
    },
  }));
};
